// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2mDl8","header":"ReportDetails_header__2lPrj","title":"ReportDetails_title__xJ2J7","left":"ReportDetails_left__32LZw"};